import superagentPromise from "superagent-promise";
import _superagent, { get } from "superagent";
import { string } from "yup";

const superagent = superagentPromise(_superagent, global.Promise);
// const API_ROOT = "192.168.0.237:3001";
const API_ROOT = "https://api.shadowzapp.com/"
const STORAGE_BASE_URL = 'https://shadowzapp.syd1.digitaloceanspaces.com/'
const API_ROOT_IMAGEUPLOAD = `https://shadowzapp.syd1.digitaloceanspaces.com/shadowzapp/medium/`;
const API_FILE_ROOT_SMALL = `${STORAGE_BASE_URL}shadowzapp/images/small/`;
const API_FILE_ROOT_MEDIUM = `${STORAGE_BASE_URL}shadowzapp/images/medium/`;
const API_FILE_ROOT_ORIGINAL = `${STORAGE_BASE_URL}shadowzapp/images/original/`;
const API_FILE_ROOT_VIDEO = `${STORAGE_BASE_URL}video/`;

const encode = encodeURIComponent;
const responseBody = (res) => res.body;

let token = null;
const tokenPlugin = (req) => {
  if (token) {
    req.set("token", `${token}`);
  }
};

const handleErrors = (err) => {
  if (err?.status === 401) {
    console.error("Unauthorized! Clearing session and redirecting to login...");
    sessionStorage.clear();
    window.location.href = "/login";
  }
  throw err;
};

const requests = {
  del: (url) =>
    superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  get: (url) =>
    superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
  patch: (url, body) =>
    superagent
      .patch(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),

  file: (url, key, file, onProgress) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .attach(key, file)
      .use(tokenPlugin)
      .then(responseBody).catch(handleErrors),


  upload: (url, key, file) =>
    superagent.post(`${API_ROOT}${url}`).attach(key, file).use(tokenPlugin).then(responseBody).catch(handleErrors),


};

const Auth = {
  login: (info) => requests.post("Admin/login", info),
  signup: (info) => requests.post("signup", info),
  forgotPassword: (info) => requests.put("Admin/forgot_password", info),
  checkOtp: (info) => requests.post("check-email-otp", info),
  resetPassword: (info) => requests.post("Admin/reset_password", info),
  changePassword: (info) => requests.put("admin/change-password", info),
};

const Dashboard = {
  getPagnation: () => requests.get(`Admin/dashboard?language=ENGLISH`),
};

const Facility = {
  getApprovalPagnation: (page, limit, filter) =>
    requests.get(
      `admin/facility/approvals?page=${page}&limit=${limit ? limit : 10}${filter ? filter : ""
      }`
    ),
  getPagnation: (page, limit, filter) =>
    requests.get(
      `admin/facilities?page=${page}&limit=${limit ? limit : 10}${filter ? filter : ""
      }`
    ),
  approvalAccept: (facility_id) =>
    requests.put("admin/facility/approval", {
      facility_id: facility_id,
      status: 1,
    }),
  approvalDecline: (facility_id) =>
    requests.put("admin/facility/approval", {
      facility_id: facility_id,
      status: 4,
    }),
  updateFee: (item) => requests.put("admin/facility/fees", item),
};

const Transaction = {
  getPagnation: (page, limit, type) =>
    requests.get(
      `Admin/all_transaction?pagination=${page}&limit=${limit}&type=${type ? type : "SEND"}`
    ),
};

const PromoCode = {
  getPagnation: (page, limit, filter) =>
    requests.get(
      `admin/transactions?page=${page}&limit=${limit ? limit : 10}${filter ? filter : ""
      }`
    ),
  createEndUser: (item) => requests.post("admin/promo_code", item),
};

const Creator = {
  export: (start_date, end_date, timezone) =>
    requests.get(
      `Admin/creator?language=ENGLISH&start_date=${start_date}&end_date=${end_date}&timezone=${timezone}`
    ),
  reported: (_id, pagination) =>
    requests.get(
      `Admin/creator/reported?language=ENGLISH&_id=${_id}&pagination=${pagination}&limit=10`
    ),
  getListing: (search, pagination, limit) =>
    requests.get(
      `Admin/creator?language=ENGLISH${search ? `&search=${search}` : ""}${pagination ? `&pagination=${pagination}` : ""
      }${limit ? `&limit=${limit}` : ""}`
    ),
  getCreatorDetails: (creatorId) =>
    requests.get(`Admin/creator/${creatorId}?language=ENGLISH`),
  getTips: (_id, pagination) =>
    requests.get(
      `Admin/creator/tip_history?language=ENGLISH&_id=${_id}&pagination=${pagination}&limit=10`
    ),
  getPhotos: (creatorId) =>
    requests.get(`Admin/creator/${creatorId}?language=ENGLISH`),
  getCreatedNfts: (_id, pagination) =>
    requests.get(
      `Admin/nfts/creator?language=ENGLISH&type=CREATED&created_by=${_id}&pagination=${pagination}&limit=10`
    ),
  getOwnNfts: (_id, pagination) =>
    requests.get(
      `Admin/nfts/creator?language=ENGLISH&type=OWN&created_by=${_id}&pagination=${pagination}&limit=10`
    ),
  getSoldNfts: (_id, pagination) =>
    requests.get(
      `Admin/nfts/creator?language=ENGLISH&type=SOLD&created_by=${_id}&pagination=${pagination}&limit=10`
    ),
  verifyProfile: (_id, admin_verified) =>
    requests.put("Admin/creator", {
      _id,
      type: "VERIFY/UNVERIFY",
      admin_verified: !admin_verified,
      language: "ENGLISH",
    }),
  manageCreators: (values) =>
    requests.put("Admin/creator", {
      type: values.type,
      _id: values._id,
      is_blocked: values.is_blocked,
      is_deleted: values.is_deleted,
      admin_verified: values.admin_verified,
      account_status: values.account_status,
      language: values.language,
    }),

  getMediaList: (creatorId) =>
    requests.get(`Admin/creator/${creatorId}?language=ENGLISH`),

  sendCredit: (info) => requests.put("admin/credit", info),
  delete: (info) => requests.del("admin/user", info),
};

const Listing = {
  getPagnation: (page, limit, filter) =>
    requests.get(
      `admin/listings?page=${page}&limit=${limit ? limit : 10}${filter ? filter : ""
      }`
    ),
};

const Administrator = {
  getStaffMemberDetail: (id) =>
    requests.get(`Admin/staff/${id}?language=ENGLISH`),

  addStaffMembers: (values) => {
    console.log("values", values);

    return requests.post(`Admin/add_staff`, values);
  },
  blockOrDeleteStaff: (values) => requests.put("Admin/add_staff", values),

  getStaffMembers: (values) =>
    requests.get(
      `Admin/add_staff?language=${values.language}&search=${values.search}&pagination=${values.page}&limit=${values.limit}`
    ),

  getPagnation: (page, limit, filter) =>
    requests.get(
      `admin/administration?page=${page}&limit=${limit ? limit : 10}${filter ? filter : ""
      }`
    ),
  changeRole: (info) => requests.put("admin/role", info),

  changePassword: (values) =>
    requests.put("Admin/change_password", {
      old_password: values.oldPass,
      new_password: values.newPass,
      language: values.language,
    }),

  editImgProfile: (values, image) =>
    requests.put(`Admin/profile`, {
      image: image,
      name: values.name,
      language: values.language,
    }),

  editProfile: (values) =>
    requests.put(`Admin/profile`, {
      name: values.name,
      image: values.image,
      language: values.language,
    }),

  sendNotifications: (values) => requests.post(`Admin/notification/broadcast`, values),
};
const Staff = {

  pagination: (q, search, page) =>
    requests.get(
      `Admin/staffs?language=ENGLISH&${search ? `${search}` : q ? `&filter=${q}` : " "
      }&pagination=${page}&limit=10`
    ),
};
const Policies = {
  // Admin/contents?language=ENGLISH&type=AGREEMENT
  all: (type) =>
    requests.get(
      `Admin/contents?language=ENGLISH${type ? `&type=${type}` : ""}`
    ),
  // Admin/contents/63352ed5abfdd3c89a9b4032
  Details: (id) =>
    requests.get(
      `Admin/contents/${id}`
    ),
  byType: (type) =>
    requests.get(`Admin/content/listing?type=${type}&language=ENGLISH`),
  addEditPolicy: (values) => requests.post(`Admin/content`, values),
  delete: (_id) => requests.del(`Admin/content/${_id}`),
};

const ContactUs = {
  pagination: (page, search) =>
    requests.get(
      `Admin/contact_us?language=ENGLISH${search ? `&search=${search}` : ""
      }&pagination=${Number(page) - 1}&limit=10`
    ),
  fetchContacts: (values) =>
    requests.get(
      `Admin/contact_us?language=${values.language}&search=${values.search}&pagination=${values.page}&limit=${values.limit}`
    ),

  deleteContact: (values) => requests.put(`Admin/contact_us`, values),

  resolveContact: (values) => requests.put(`Admin/contact_us`, values),
};

const Profile = {
  get: () => requests.get(`admin/profile`),
  getById: (id) => requests.get(`profile?id=${id}`),
  update: (info) => requests.put(`admin/profile`, info),
};

const Faq = {
  addFaq: (values) => requests.post(`Admin/faqs`, values),
  editFaq: (values) => requests.post(`Admin/faqs`, values),
  pagination: (page, search) =>
    requests.get(
      `Admin/faqs?language=ENGLISH${search ? `&search=${search}` : ""
      }&pagination=${Number(page) - 1}&limit=10`
    ),
  getFaqById: (values) =>
    requests.get(`Admin/faqs?language=${values.language}&_id=${values._id}`),
  deleteFaq: (id) => requests.del(`Admin/faqs/${id}`),
};


const Reports = {
  pagination: (pagination) =>
    requests.get(
      `Admin/reported?language=ENGLISH&pagination=${pagination}&limit=10`
    ),
  getFaqById: (values) =>
    requests.get(`Admin/reported?language=ENGLISH&_id=${values._id}`),
};

const Common = {
  get: (url) => requests.get(url),

  uploadFile: (key, file) => requests.file(`Upload/do_spaces_file_upload`, key, file, {}),

  uploadFileMultiple: (key, file) =>
    requests.file(`Upload/do_spaces_file_upload_multiple`, key, file, {}),

  dbBackup: () =>
    requests.post(`admin/db/backup`, {}),

  ethusd: () =>
    superagent.get(
      `https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=ETH,USD`
    ),
  allUsers: (search) =>
    requests.get(
      `Admin/users?language=ENGLISH${search ? `&search=${search}` : ""
      }&pagination=0&limit=10`
    ),
  staticData: () => requests.get(`static-data`),
  getSales: (pagination) =>
    requests.get(
      `Admin/sales?language=ENGLISH&pagination=${pagination}&limit=10`
    ),
  export: (start_date, end_date, timezone) =>
    requests.get(
      `Admin/sales?language=ENGLISH&start_date=${start_date}&end_date=${end_date}&timezone=${timezone}`
    ),
  getSalesDetails: (_id, pagination) =>
    requests.get(
      `Admin/sales?language=ENGLISH&_id=${_id}&pagination=${pagination}&limit=10`
    ),
  all_languages: () => requests.get(`admin/all_languages`),
  all_counrties: () => requests.get(`admin/all_counrties`),
  addCountries: (name) => requests.post(`admin/countries`, { name: name }),
  addLanguage: (name) => requests.post("admin/languages", { name: name }),
  backupDb: (bodyData, config) =>
    requests.post("Admin/backup", bodyData, config),
  activateDeactivate: (data) => requests.put("Admin/post_active_deactive", data),
};
const Message = {
  send: (items) => requests.post("admin/message", items),
};

// const Nfts = {
//   export: (start_date, end_date, timezone) =>
//     requests.get(
//       `Admin/nfts?language=ENGLISH&start_date=${start_date}&end_date=${end_date}&timezone=${timezone}`
//     ),

//   pagination: (page, search) =>
//     requests.get(
//       `Admin/nfts?language=ENGLISH${
//         search ? `&search=${search}` : ""
//       }&pagination=${Number(page) - 1}&limit=12`
//     ),

//   reports: (_id) =>
//     requests.get(`Admin/nfts/reported?language=ENGLISH&nft_id=${_id}`),
//   allReports: (_id) => requests.get(`Admin/nfts/reported?language=ENGLISH`),
//   details: (_id, graph_type, timezone) =>
//     requests.get(
//       `Admin/nfts/details?language=ENGLISH&_id=${_id}&graph_type=${String(
//         graph_type
//       ).toUpperCase()}&timezone=${timezone}`
//     ),
//   delete: (info) => requests.put(`Admin/nfts/delete`, info),
//   recovery: (info) => requests.put(`Admin/nfts/recovery`, info),
// };
const User = {
  getListing: (search, q, pagination, limit) => {
    return requests.get(
      `Admin/users?language=ENGLISH${search ? `&search=${search}` : q ? `&${q}` : " "
      }&pagination=${pagination}&limit=${limit}`
    );

  },
  userEmailList: (search) => {
    return requests.get(
      `Admin/users?language=ENGLISH${search ? `&search=${search}` : ""}`)
  },
  // const User = {
  //   getListing: (search, pagination, limit) => {
  //     return requests.get(
  //       `Admin/users?language=ENGLISH${
  //         search ? `&search=${search}` : ""
  //       }&pagination=${pagination}&limit=${limit}`
  //     );
  //   },

  getTips: (_id, pagination) =>
    requests.get(
      `Admin/users/tip_history?language=ENGLISH&_id=${_id}&pagination=${pagination}&limit=10`
    ),
  // getUserDetails: (_id) =>
  //   requests.get(`Admin/user?_id=${_id}&type=${1}&language=ENGLISH&pagination=${page}&limit=${limit}`),
  getUserDetailsPosts: (_id, type, page, limit) =>
    requests.get(`Admin/user?_id=${_id}&type=${type}&language=ENGLISH&pagination=${page}&limit=${limit}`),
  // getUserDetailsReels: (_id) =>
  //   requests.get(`Admin/user?_id=${_id}&type=${2}&language=ENGLISH&pagination=${page}&limit=${limit}`),
  // getUserDetailsStory: (_id) =>
  //   requests.get(`Admin/user?_id=${_id}&type=${3}&language=ENGLISH&pagination=${page}&limit=${limit}`),
  getUserActivity: (_id, page, limit) =>
    requests.get(`Admin/user?_id=${_id}&type=${4}&language=ENGLISH&pagination=${page}&limit=${limit}`),
  getUserChatListing: (_id) =>
    requests.get(`Admin/chat/listing?_id=${_id}&language=ENGLISH`),
  // Admin/user/listing?user_id=632c11edc7f3dd444a29026f&_id=6333d0afddd7eaa75a08885a&chat_type=1
  getUserChatHistory: (_id, connection_id) =>
    requests.get(
      `Admin/user/listing?user_id=${_id}&_id=${connection_id}&chat_type=${1}`
    ),
  // Admin/transactions?_id=6336e5ad79979d8fd0b510f2&transaction_type=1&pagination=0&limit=3&language=ENGLISH
  getUserDetailsCoinHistorySend: (_id, page, limit) =>
    requests.get(
      `Admin/transactions?_id=${_id}&transaction_type=${1}&pagination=0&limit=100&language=ENGLISH`
    ),
  getUserDetailsCoinHistoryReceive: (_id, page, limit) =>
    requests.get(
      `Admin/transactions?_id=${_id}&transaction_type=${2}&pagination=0&limit=100&language=ENGLISH`
    ),
  getUserDetailsCoinHistoryPurchased: (_id, page, limit) =>
    requests.get(
      `Admin/transactions?_id=${_id}&transaction_type=${3}&pagination=0&limit=100&language=ENGLISH`
    ),
  getUserDetailsCoinHistoryWithdraw: (_id, page, limit) =>
    requests.get(
      `Admin/transactions?_id=${_id}&transaction_type=${4}&pagination=0&limit=100&language=ENGLISH`
    ),
  manageUsers: (data) => requests.put("Admin/activate_deactivate", data),
};
const Posts = {
  export: (q) => requests.get(`Admin/posts`),
  // Admin/posts?filter=Live&pagination=0&limit=10
  pagination: (q, page, limit) =>
    requests.get(
      `Admin/posts?${q ? `${q}` : ""}&pagination=${page}&limit=${limit}`
    ),
  delete: (_id) => requests.put(`Admin/remove_post/${_id}`),
  tags: (_id) => requests.get(`Admin/tagged_posts?post_id=${_id}`),
  coins: (_id) => requests.get(`Admin/coins?post_id=${_id}`),
  like: (_id) => requests.get(`Admin/likes_comments?post_id=${_id}&type=${1}`),
  Comment: (_id) =>
    requests.get(`Admin/likes_comments?post_id=${_id}&type=${2}`),
};

const Stories = {
  export: () => requests.get(`Admin/stories`),
  pagination: (q, page, limit) =>
    requests.get(
      `Admin/stories?${q ? `${q}` : " "}&pagination=${page}&limit=${limit}`
    ),
  delete: (_id) => requests.put(`Admin/remove_story/${_id}`),
  view: (_id) => requests.get(`Admin/views?post_id=${_id}`),
  reply: (_id) => requests.get(`Admin/story_replies?post_id=${_id}`),
};

const Reels = {
  export: () => requests.get(`Admin/reels`),
  pagination: (q, page, limit) =>
    requests.get(
      `Admin/reels?${q ? `${q}` : ""}&pagination=${page}&limit=${limit}`
    ),
  delete: (_id) => requests.put(`Admin/remove_reel/${_id}`),
};

const Race = {
  listing: (q) =>
    requests.get(`Admin/races?${q}`),

  export: (start_date, end_date) =>
    requests.get(`Admin/users/export?start_date=${start_date}&end_date=${end_date}`),

  getById: (id) =>
    requests.get(`Admin/races/details/${id}`),

  create: (info) =>
    requests.post(`Admin/race/create`, info),

  update: (info) =>
    requests.post(`Admin/race/create`, info),

  deactivate: (info) =>
    requests.patch(`Admin/users/account_status`, info),

  delete: (id) =>
    requests.del(`Admin/users/${id}`),

  import: (file) =>
    requests.file(`Admin/users/import`, 'file', file, {})
};

const Reported = {
  // Admin/reports?type=1&pagination=0&limit=4&language=ENGLISH
  export: () => requests.get(`Admin/reports`),
  post: (type, page, limit, q) =>
    requests.get(
      `Admin/reports?type=${type}
      &pagination=${page}&limit=${limit}&language=ENGLISH${q ? `&${q}` : ""}`
    ),
  stories: (type, page, limit, q) =>
    requests.get(
      `Admin/reports?type=${type}
      &pagination=${page}&limit=${limit}&language=ENGLISH${q ? `&${q}` : ""}`
    ),
  reels: (type, page, limit, q) =>
    requests.get(
      `Admin/reports?type=${type}
      &pagination=${page}&limit=${limit}&language=ENGLISH${q ? `&${q}` : ""}`
    ),
    reportedChatList: (type, pagination = 0, limit = 10) =>
    requests.get(
      `Admin/reported_chat/list?type=${type}&pagination=${pagination}&limit=${limit}`
    ),
    reportedMessage: (id) =>
    requests.get(
      `Admin/reported_messages/${id}`
    ),
};
const Queries = {
  // Admin/queries?language=ENGLISH&filter=unReplyMessage
  export: () => requests.get(`Admin/queries`),
  pagination: (page, search) =>
    requests.get(
      `Admin/reels?filter=All${search ? `&search=${search}` : ""}&pagination=${Number(page) - 1
      }&limit=12`
    ),
  // Admin/user_messages?_id=6336b3d4fec8c07c30732501&language=ENGLISH

  queriesUser: (page, limit, q) =>
    requests.get(`Admin/queries?language=ENGLISH&pagination=${page}&limit=${limit}${q ? `&${q}` : ""}`),
  queriesUserDetails: (_id) =>
    requests.get(`Admin/user_messages?_id=${_id}&language=ENGLISH`),
  queriesReplyApi: (data) => requests.post(`Admin/query_messages`, data),
};

const Suscribe = {
  listing: (page, limit, q) =>
    requests.get(`Admin/subscriber-list?language=ENGLISH&pagination=${page}&limit=${limit}${q ? `&${q}` : ""}`),
}
const Media = {
  details: (id) =>
    requests.get(`Admin/media/${id}?language=ENGLISH`),
  activity: (_id, type) => requests.get(`Admin/likes_comments?post_id=${_id}&type=${type}`),
  tags: (_id) => requests.get(`Admin/tagged_posts?post_id=${_id}`),

}


//Activate And Deactivate
export default {
  Reported,
  Reels,
  Media,
  Stories,
  Posts,
  Suscribe,
  Queries,
  token,
  ContactUs,
  Faq,
  Reports,
  Auth,
  Administrator,
  Staff,
  Common,
  Profile,
  Dashboard,
  Facility,
  Listing,
  Transaction,
  PromoCode,
  User,
  Policies,
  Creator,
  Message,
  Race,
  // Nfts,
  API_ROOT,
  API_FILE_ROOT_SMALL,
  API_ROOT_IMAGEUPLOAD,
  API_FILE_ROOT_MEDIUM,
  API_FILE_ROOT_ORIGINAL,
  API_FILE_ROOT_VIDEO,
  setToken: (_token) => {
    token = _token;
  },
};
